/* v2.8.4 - '/' tusu arama alanina odaklanir (form alanlarinda yazarken devre disi). */
(function () {
  'use strict';
  addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    var input = document.querySelector('input[type="search"], .search__input, #Search-In-Modal, input[name="q"]');
    if (!input) return;
    e.preventDefault();
    var opener = document.querySelector('details[open] .search__input') ? null : document.querySelector('.header__icon--search, [aria-controls*="earch" i]');
    if (opener && input.offsetParent === null) opener.click();
    setTimeout(function () {
      var vis = document.querySelector('input[type="search"], .search__input, input[name="q"]');
      if (vis) { vis.focus(); vis.select && vis.select(); }
    }, 60);
  });
})();
